import { Headline3 } from '@nexus/lib-react/dist/core/Typography';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import { ConfirmationPage } from '@nexus/lib-react/dist/core/ConfirmationPage/ConfirmationPage';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import styled from '../../../theme/styled';

import mq from '../../styles/mediaQueries';

const Page = styled(ConfirmationPage)`
  min-height: 100vh;
  padding: 64px 32px 32px;

  ${mq.desktop} {
    min-height: auto;
    padding: 63px 219px;
  }
`;

const PageContainer = styled.div`
  ${mq.desktop} {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 64px;
  }
`;

const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  height: auto;
  width: 100%;

  ${mq.desktop} {
    padding: 16px;
    width: 792px;
    background: white;
    margin-top: 64px;
  }
`;

const Headline = styled(Headline3)`
  margin: 32px 0 48px;

  ${mq.desktop} {
    margin: 16px 0 32px;
  }
`;

const Paragraph = styled(Paragraph4)`
  margin-bottom: 62px;
  text-align: center;
  color: ${({ theme }) => theme.colors.charcoal};

  ${mq.desktop} {
    margin: 0 0 32px;
    padding: 0 35px;
  }
`;

const ActionButton = styled(ButtonPrimaryDark)`
  margin-bottom: 20px;
  ${mq.desktop} {
    margin-bottom: 16px;
  }
`;

export default {
  Wrapper,
  Paragraph,
  Page,
  PageContainer,
  Headline,
  ActionButton,
};
